import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  edit(event) {
    const id = event.currentTarget.dataset.bookmarkId
    const currentName = event.currentTarget.dataset.bookmarkName
    const newName = prompt('Edit bookmark name:', currentName)
    
    if (newName && newName !== currentName) {
      const form = document.createElement('form')
      form.method = 'POST'
      form.action = `/chair_arrangements/${id}/update_bookmark`
      form.innerHTML = `
        <input type="hidden" name="_method" value="PATCH">
        <input type="hidden" name="authenticity_token" value="${document.querySelector('meta[name="csrf-token"]').content}">
        <input type="hidden" name="name" value="${newName}">
      `
      document.body.appendChild(form)
      form.submit()
    }
  }
}